// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__Rb3Ff {
  height: 100%;
  display: flex;
}

.styles_contentWrapper__fSM0q {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(50px);
          backdrop-filter: blur(50px);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 32px;
  transition: all 500ms;
}

.styles_text__yzMyA,
.styles_link__LEUgw {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
}
@media (max-width: 1200px) {
  .styles_text__yzMyA,
.styles_link__LEUgw {
    font-size: 12px;
    line-height: 15px;
  }
}

.styles_text__yzMyA {
  color: rgba(255, 255, 255, 0.5);
}

.styles_link__LEUgw {
  color: #ff136d;
}

.styles_heading__dG640 {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_heading__dG640 {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Policy/content/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,aAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BCIS;EDHT,mCAAA;UAAA,2BAAA;EACA,qCAAA;EACA,mBAAA;EACA,qBAAA;AAFF;;AAKA;;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AAFF;AEJE;EFCF;;IAQI,eAAA;IACA,iBAAA;EAAF;AACF;;AAGA;EACE,+BC5BS;AD4BX;;AAGA;EACE,cC5BK;AD4BP;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BCvCS;ADuCX;AE5BE;EFsBF;IASI,eAAA;EACF;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  height: 100%;\n  display: flex;\n}\n\n.contentWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  background: $black-30;\n  backdrop-filter: blur(50px);\n  border: 1px solid $black-15;\n  border-radius: 32px;\n  transition: all 500ms;\n}\n\n.text,\n.link {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n\n  @include xl {\n    font-size: 12px;\n    line-height: 15px;\n  }\n}\n\n.text {\n  color: $white-50;\n}\n\n.link {\n  color: $pink;\n}\n\n.heading {\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-80;\n\n  @include xl {\n    font-size: 16px;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__Rb3Ff`,
	"contentWrapper": `styles_contentWrapper__fSM0q`,
	"text": `styles_text__yzMyA`,
	"link": `styles_link__LEUgw`,
	"heading": `styles_heading__dG640`
};
export default ___CSS_LOADER_EXPORT___;
